export default __webpack_public_path__ + "static/media/top10.12974d54.jpg";